import React from 'react';
import AgencyNavbar from '../components/agencies/AgencyNavbar';
import { Link } from 'react-router-dom';
import PartnerPaths from '../components/agencies/PartnerPaths';
import Footer from '../components/layout/Footer';
import PartnerUpgrades from '../components/agencies/PartnerUpgrades';

export default function CertifiedPartner() {
  return (
    <div className="min-h-screen bg-[#F7F8F7] font-lexend text-[#101F1F]">
      <AgencyNavbar />
      <main id="main-content" className="pt-32">
        <section className="mx-auto max-w-5xl px-6 py-16">
          <p className="font-michroma text-xs uppercase tracking-widest text-[#D35E0E]">Agency Partner</p>
          <h1 className="mt-5 text-4xl font-bold sm:text-6xl">Your clients have happy customers. Turn that praise into a recurring service.</h1>
          <p className="mt-6 text-lg leading-8">Help clients put the words people use to recommend them to work in review replies, articles, and social posts. Your agency leads the relationship, approves the content, and handles first-line support.</p>
          <p className="mt-5 leading-7">Agency Partner Dominate is $299/month, or $99/month with five qualifying active paying client businesses. It includes the full Complete feature set for one partner-owned location. Approved agency partners earn 50% commission on referred client subscriptions. Client subscriptions are separate.</p>
          <Link to="/partner-apply" className="mt-8 inline-flex min-h-12 items-center rounded-xl bg-[#244A49] px-7 py-4 font-bold text-white">Apply to partner →</Link>
        </section>
        <PartnerUpgrades />
        <PartnerPaths />
      </main>
      <Footer audience="agency" />
    </div>
  );
}